<template>
  <div id="submission-history">
    <div class="submission-list-history-header">
      <ul>
        <li>{{$_('submission_deadline')}}</li>
        <li>{{$_('submission_date')}}</li>
        <li>{{$_('status')}}</li>
        <li>{{$_('date_of_acceptance')}}</li>
        <li>{{$_('code_sample')}}</li>
        <li>{{$_('tracking')}}</li>
      </ul>
    </div>
    <div class="submission-list-history-body" v-if="items.length > 0">
      <div v-for="(item, index) in items" :key="index" class="submission-line-history">
        <div class="submission-cell-history">
          <span>{{$dateformat(item.TDELAI_SOUM)}}</span>
        </div>
        <div class="submission-cell-history">
          <span>{{$dateformat(item.TDATE_SOUM)}}</span>
        </div>
        <div class="submission-cell-history">
          <span>{{item.TLIB_AR}}</span>
        </div>
        <div class="submission-cell-history">
          <span>{{$dateformat(item.TDATE_ACC)}}</span>
        </div>
        <div class="submission-cell-history">
          <span>{{item.TCECH_ACC}}</span>
        </div>
        <div class="submission-cell-history">
          <a v-if="item.THTTP_TRACK !== '' " target="_blank" :href="item.THTTP_TRACK">{{$_('tracking_link')}}</a>
        </div>
      </div>
    </div>
    <div v-else class="no-result">
      <span>{{$_('no_history')}}</span>
    </div>
  </div>
</template>

<script>

import submissionService from '@/modules/soumission/services/submissionService';

export default {
  name: 'SubmissionHistory',
  props: {
    tnsoum: {
      type: Number,
    },
    load: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      items: Array(),
    }
  },
  watch: {
    load(val) {
      if(val) {
        submissionService.getSubmissionHistory(this.$props.tnsoum)
        .then(res => {
          if(res.data.DS_O !== undefined) {
            res.data.DS_O.OUT.map(obj => {
              this.items = Array();
              this.items.push(obj);
            })
          }
        }).catch(err => {
          console.error(err);
        })
      }
    }
  }
}
</script>

<style scoped>
#submission-history {
  border: solid 1px #E9E9E9;
  padding: 15px;
}
.submission-list-history-header ul {
  display: flex;
}
.submission-list-history-header ul li {
  list-style-type: none;
  width: calc(100% / 6);
  font-size: var(--fz-md);
}
.submission-line-history {
  display: flex;
  padding: 15px 0px;
  border-bottom: solid 1px #E9E9E9;
}
.submission-cell-history {  
  width: calc(100% / 6);
}
.submission-cell-history span {
  font-size: var(--fz-md);
  color: #8e8d8d;
}
.no-result {
  text-align: center;
  padding: 20px 20px 10px;
  border-top: solid 1px #E9E9E9;
  margin-top: 20px;
}
.no-result span {
  font-size: var(--fz-md);
  color: #BFBFBF;
}
</style>